import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * Line icons for the phone/tablet Reports chrome. `Reports - Mobile &
 * Tablet.dc.html` draws them as inline stroked SVGs rather than Material
 * glyphs, so they are traced from it here.
 *
 * They inherit `currentColor`; size comes from the caller's `sx`.
 */

const strokeProps = {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

/** Tick inside a selected checkbox. */
export const CheckGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path {...strokeProps} strokeWidth={3.2} d="M20 6L9 17l-5-5" />
  </SvgIcon>
);

/** Tray-and-arrow on the Download Report button. */
export const DownloadGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path {...strokeProps} strokeWidth={2.2} d="M12 3v13M8 12l4 4 4-4M4 21h16" />
  </SvgIcon>
);

/** Magnifier in the search field. */
export const SearchGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <circle {...strokeProps} strokeWidth={2} cx="11" cy="11" r="7" />
    <path {...strokeProps} strokeWidth={2} d="m21 21-4.3-4.3" />
  </SvgIcon>
);

/** Pager arrow; flipped with a transform for the previous step. */
export const ChevronGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path {...strokeProps} strokeWidth={2.2} d="M9 6l6 6-6 6" />
  </SvgIcon>
);
